import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";

import { UiInput, UiButton, BgLoader, OverlayLoader } from "../ui";

import ImageUploader from "../components/ImageUploader";
import SortableImageGrid from "../components/SortableImageGrid";

const Color = NiceModal.create(
    ({ id, defaultImages = [] }) => {

        const modal = useModal();

        const [state, setState] = useState({});
        const [selectedRowKeys] = useState([]);

        const [images, setImages] = useState(
            defaultImages.map(img => ({
                id: img.id,
                url: img.url
            }))
        );

        const [deleted, setDeleted] = useState([]);

        const schema = yup.object().shape({
            name: yup.string().required("Enter color name")
        });

        const {
            register,
            handleSubmit,
            formState: { errors },
            reset
        } = useForm({
            resolver: yupResolver(schema)
        });

        const onSubmitHandler = async (data) => {
            SaveTag(data);
        };

        const SaveTag = (e) => {

            e = {
                ...e,
                groups: selectedRowKeys,
                images: images.map((img, index) => ({
                    id: img.id,
                    order: index
                })),
                deleted
            };

            setState({ ...state, loader: true });

            instance({
                method: "post",
                url: "/update_color",
                data: e,
                headers: { "Content-Type": "application/json" }
            })
                .then(function (response) {

                    setState({ ...state, loader: false });

                    if (response.data.status === "error") {
                        toast(response.data.msg, { type: "error" });
                    }

                    if (response.data.status === "success") {

                        toast(response.data.msg, { type: "success" });

                        modal.resolve({ resolved: true });
                        modal.hide();

                    }

                })
                .catch(function () {
                    setState({ ...state, loader: false });
                });

        };

        const fetchData = () => {

            instance
                .get("/get_color?id=" + id)
                .then(function (response) {

                    setState(response.data);

                    reset(response.data.item);

                    if (response.data.images) {

                        setImages(
                            response.data.images.map(img => ({
                                id: img.id,
                                url: img.url
                            }))
                        );

                    }

                })
                .catch(function () { });

        };

        useEffect(() => {

            fetchData();

            if (id === "new") {
                reset({ status: true });
            }

        }, []);

        const handleHide = () => {
            modal.hide();
        };

        return (

            <BootstrapModal {...bootstrapDialog(modal)} onHide={handleHide}>

                <BootstrapModal.Header closeButton>
                    <BootstrapModal.Title>Color</BootstrapModal.Title>
                </BootstrapModal.Header>


                <BootstrapModal.Body>

                    {state.status ? (

                        <form id="colorform" onSubmit={handleSubmit(onSubmitHandler)}>

                            <UiInput
                                label="Name"
                                type="text"
                                required
                                name="name"
                                {...register("name")}
                                message={errors.name?.message}
                            />

                            <input
                                type="hidden"
                                value={id}
                                name="id"
                                {...register("id")}
                            />

                            <div className="mt-4">

                                <label className="form-label">Images</label>

                                <ImageUploader
                                    onUploaded={(img) =>
                                        setImages(prev => [...prev, img])
                                    }
                                />

                                <SortableImageGrid
                                    images={images}
                                    setImages={setImages}
                                    onDelete={(img) => {
                                        console.log(img);
                                        setDeleted(prev => [...prev, img.id]);

                                        setImages(prev =>
                                            prev.filter(i => i.id !== img.id)
                                        );

                                    }}
                                />

                            </div>

                            <UiButton
                                className="btn btn-primary mt-4"
                                type="submit"
                                title="Save"
                                loading={state.loader}
                            />

                        </form>

                    ) : (

                        <BgLoader />

                    )}

                </BootstrapModal.Body>

            </BootstrapModal>

        );

    }
);

export default Color;